// extracted by mini-css-extract-plugin
module.exports = {"root":"Right_root__b5i65","title":"Right_title__R8tl9","source":"Right_source__1ISe8"};